import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CodeToHtmlPipe, SectionHeaderComponent } from '@app/widgets';

@Component({
  selector: 'app-app-store-publishing-automation-section',
  imports: [AsyncPipe, CodeToHtmlPipe, SectionHeaderComponent],
  templateUrl: './app-store-publishing-automation-section.component.html',
  styleUrl: './app-store-publishing-automation-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStorePublishingAutomationSectionComponent {
  public readonly code = `name: Deploy to Stores

on:
  push:
    tags:
      - 'v*'

jobs:
  deploy:
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4

      - name: Build app
        id: build
        run: |
          BUILD_ID=$(npx @capawesome/cli apps:builds:create \\
            --app-id \${{ secrets.CAPAWESOME_CLOUD_APP_ID }} \\
            --git-ref main \\
            --platform android \\
            --json | jq -r '.id')
          echo "build_id=$BUILD_ID" >> $GITHUB_OUTPUT
        env:
          CAPAWESOME_CLOUD_TOKEN: \${{ secrets.CAPAWESOME_CLOUD_TOKEN }}

      - name: Deploy to Google Play Store
        run: |
          npx @capawesome/cli apps:deployments:create \\
            --app-id \${{ secrets.CAPAWESOME_CLOUD_APP_ID }} \\
            --build-id \${{ steps.build.outputs.build_id }} \\
            --destination play-store
        env:
          CAPAWESOME_CLOUD_TOKEN: \${{ secrets.CAPAWESOME_CLOUD_TOKEN }}`;
}
